import Vue from 'vue'
import Vuex from 'vuex'
import language from './modules/language'
import refuge from './modules/refuge'
import booking from './modules/booking'
import user from './modules/user'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules:{
    language,
    refuge,
    booking,
    user
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/_store/index.js